import { Loader } from "@atoms";
import {
  actions,
  getGroupById,
  groupsIsLoading,
  groupWorkdaysIsLoading,
  useAppDispatch,
  useAppSelector,
} from "@lib/store";
import { Canvas } from "@templates";
import { useEffect, useMemo } from "react";
import { Outlet, useParams } from "react-router";
import { Navigate } from "react-router-dom";
import { GROUP_DATA_DATE_RANGE } from "@lib/store/src/data/groups/constants";
import { useConnectBreadCrumbs } from "./BreadCrumbs";

type Props = {};

export const GroupOutlet = (props: Props) => {
  const { groupId = "" } = useParams<{ groupId: string }>();
  const dispatch = useAppDispatch();
  const group = useAppSelector(state => getGroupById(state, groupId || ""));

  const { paths } = useConnectBreadCrumbs();
  const goBackPath = paths.at(-2) ?? "/connect";

  const isLoadingGroups = useAppSelector(groupsIsLoading);
  const isLoadingGroupWorkdays = useAppSelector(state => groupWorkdaysIsLoading(state, groupId));

  const loading = useMemo(() => {
    return isLoadingGroups || isLoadingGroupWorkdays;
  }, [isLoadingGroups, isLoadingGroupWorkdays]);

  useEffect(() => {
    dispatch(actions.loadGroupWorkdays({ groupId, range: GROUP_DATA_DATE_RANGE }));
  }, [dispatch, groupId]);

  if (loading && !group) {
    return (
      <Canvas centerContent>
        <Loader />
      </Canvas>
    );
  }

  if (!loading && !group) {
    return (
      <Navigate
        to={goBackPath}
        replace
      />
    );
  }

  return <Outlet />;
};
